import Cookies from 'js-cookie'
import { mapCartForStorefront } from '@/services/shopify/lib/extend/mappers/cart.mapper'
import { updateCartDiscountsMutation } from '@/services/shopify/lib/extend/gql/cart.gql'

export const createDiscountMethods = ({ query, setLocalCart, getCartID }) => {
  return {
    add: async (codeToAdd) => {
      const variables = {
        cartId: getCartID(),
        discountCodes: [codeToAdd],
      }

      const {
        cartDiscountCodesUpdate: { cart },
      } = await query('discount.add', updateCartDiscountsMutation, variables)
      await setLocalCart(mapCartForStorefront(cart))
    },
    remove: async () => {
      const variables = {
        cartId: getCartID(),
        discountCodes: [],
      }

      const {
        cartDiscountCodesUpdate: { cart },
      } = await query('discount.remove', updateCartDiscountsMutation, variables)
      await setLocalCart(mapCartForStorefront(cart))
    },
  }
}
